import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

type TermsMarkdownProps = {
  content: string;
  className?: string;
};

export const TermsMarkdown = ({ content, className = "" }: TermsMarkdownProps) => (
  <div className={`break-words text-[0.9375rem] leading-8 text-slate-700 ${className}`.trim()}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => <h1 className="mb-4 mt-6 text-2xl font-bold leading-tight text-slate-950 first:mt-0">{children}</h1>,
        h2: ({ children }) => <h2 className="mb-3 mt-6 text-xl font-bold leading-tight text-slate-950 first:mt-0">{children}</h2>,
        h3: ({ children }) => <h3 className="mb-2 mt-5 text-lg font-bold leading-snug text-slate-900 first:mt-0">{children}</h3>,
        p: ({ children }) => <p className="my-3 whitespace-pre-wrap">{children}</p>,
        ul: ({ children }) => <ul className="my-3 list-disc space-y-1 pl-6">{children}</ul>,
        ol: ({ children }) => <ol className="my-3 list-decimal space-y-1 pl-6">{children}</ol>,
        blockquote: ({ children }) => <blockquote className="my-4 border-l-4 border-blue-200 bg-blue-50 px-4 py-2 text-slate-600">{children}</blockquote>,
        table: ({ children }) => <div className="my-4 overflow-x-auto"><table className="min-w-[42rem] border-collapse text-sm">{children}</table></div>,
        th: ({ children }) => <th className="border border-slate-200 bg-slate-50 px-3 py-2 text-left font-bold text-slate-900">{children}</th>,
        td: ({ children }) => <td className="border border-slate-200 px-3 py-2 align-top">{children}</td>,
        a: ({ children, href }) => <a className="font-semibold text-blue-600 underline" href={href} rel="noreferrer" target="_blank">{children}</a>,
      }}
    >
      {content}
    </ReactMarkdown>
  </div>
);
